import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card operations" }
const _hoisted_2 = { class: "card-header pb-0" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "grid mt-2" }
const _hoisted_5 = { class: "col-7 pb-0" }
const _hoisted_6 = { class: "grid align-items-center" }
const _hoisted_7 = { class: "col-7 pb-0" }
const _hoisted_8 = { class: "p-fluid" }
const _hoisted_9 = { class: "col-4 pb-0" }
const _hoisted_10 = { class: "p-fluid" }
const _hoisted_11 = { class: "col-1 pb-0 text-center" }
const _hoisted_12 = { class: "flex gap-2 mt-3" }
const _hoisted_13 = { class: "p-fluid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FieldNumber = _resolveComponent("FieldNumber")!
  const _component_IconPark = _resolveComponent("IconPark")!
  const _component_PrimeVueButton = _resolveComponent("PrimeVueButton")!
  const _component_FieldTextarea = _resolveComponent("FieldTextarea")!
  const _component_PrimeVueDialog = _resolveComponent("PrimeVueDialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h6", null, _toDisplayString(_ctx.title), 1)
      ])
    ]),
    (_ctx.customRevshares.length)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.entryTitle), 1),
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "col-4 pb-0" }, "RevShare", -1))
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customRevshares, (customRevshare, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "insights mt-2 mb-0 px-2 py-2",
              key: index
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _renderSlot(_ctx.$slots, "key", { customRevshare: customRevshare })
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_FieldNumber, {
                      class: "mb-0",
                      modelValue: customRevshare.revshare,
                      "onUpdate:modelValue": ($event: any) => ((customRevshare.revshare) = $event),
                      modelModifiers: { number: true },
                      min: 1,
                      max: 200,
                      step: 5,
                      "show-buttons": "",
                      "button-layout": "horizontal",
                      "increment-button-icon": "pi pi-plus",
                      "decrement-button-icon": "pi pi-minus",
                      suffix: "%"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _withDirectives(_createVNode(_component_IconPark, {
                    class: "cursor-pointer text-pink-600",
                    type: "delete",
                    theme: "outline",
                    size: "16",
                    onClick: ($event: any) => (_ctx.deleteCustomRevshare(index))
                  }, null, 8, ["onClick"]), [
                    [
                      _directive_tooltip,
                      _ctx.$t('delete'),
                      void 0,
                      { right: true }
                    ]
                  ])
                ])
              ])
            ]))
          }), 128))
        ], 64))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_PrimeVueButton, {
        class: "p-button-success p-button-outlined flex-1",
        icon: "pi pi-plus",
        onClick: _ctx.addCustomRevshare
      }, null, 8, ["onClick"]),
      (_ctx.allowBulk)
        ? _withDirectives((_openBlock(), _createBlock(_component_PrimeVueButton, {
            key: 0,
            class: "p-button-success p-button-outlined flex-1",
            icon: "pi pi-list",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.bulkDialog = true))
          }, null, 512)), [
            [_directive_tooltip, _ctx.$t('add')]
          ])
        : _createCommentVNode("", true)
    ]),
    (_ctx.allowBulk)
      ? (_openBlock(), _createBlock(_component_PrimeVueDialog, {
          key: 1,
          visible: _ctx.bulkDialog,
          "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.bulkDialog) = $event)),
          header: _ctx.title,
          style: { width: '30vw' },
          breakpoints: { '960px': '75vw', '640px': '90vw' }
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_PrimeVueButton, {
              class: "p-button-outlined p-button-success w-full m-0",
              label: _ctx.$t('add'),
              icon: "pi pi-plus",
              onClick: _ctx.bulkAddCustomRevshares
            }, null, 8, ["label", "onClick"])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_FieldTextarea, {
                modelValue: _ctx.bulkKeysInput,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.bulkKeysInput) = $event)),
                label: _ctx.entryTitle
              }, null, 8, ["modelValue", "label"]),
              _createVNode(_component_FieldNumber, {
                class: "mb-0",
                modelValue: _ctx.bulkRevshare,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.bulkRevshare) = $event)),
                modelModifiers: { number: true },
                label: _ctx.$t('revshare'),
                min: 1,
                max: 200,
                step: 5,
                "show-buttons": "",
                "button-layout": "horizontal",
                "increment-button-icon": "pi pi-plus",
                "decrement-button-icon": "pi pi-minus",
                suffix: "%"
              }, null, 8, ["modelValue", "label"])
            ])
          ]),
          _: 1
        }, 8, ["visible", "header"]))
      : _createCommentVNode("", true)
  ]))
}